<script>
export default {
  name: "BrandMark",
  props: {
    animated: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<template>
  <svg
    class="brand-mark-svg"
    :class="{ 'is-animated': animated }"
    viewBox="0 0 320 310"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <polygon
      class="arc arc--back"
      pathLength="100"
      points="283.9,225.4 233.1,221.8 244.6,61.1 98,62.9 97.4,12 299.3,9.5"
    />
    <polygon
      class="arc arc--mid"
      pathLength="100"
      points="211.6,295.3 14.4,297.9 29.8,82 80.6,85.6 69.2,246.2 210.9,244.4"
    />
    <polygon
      class="arc arc--front"
      pathLength="100"
      points="260.7,268.4 41.4,270.9 58.7,33.9 109.5,34 96.2,219.3 264.5,217.4"
    />
    <polygon
      class="arc arc--front"
      pathLength="100"
      points="264.5,217.9 213.3,217.9 223,82.7 55.1,84.5 58.8,33.6 277.7,31.1"
    />
  </svg>
</template>

<style lang="scss" scoped>
.brand-mark-svg {
  display: block;
  width: 100%;
  height: 100%;
  overflow: visible;
}

.arc {
  fill: $color-white-text;
  stroke: none;
}

.arc--back {
  --arc-opacity: 0.2;
  --arc-delay: 0ms;
  opacity: 0.2;
}

.arc--mid {
  --arc-opacity: 0.16;
  --arc-delay: 160ms;
  opacity: 0.16;
}

.arc--front {
  --arc-opacity: 1;
  --arc-delay: 320ms;
  opacity: 1;
}

.is-animated .arc {
  stroke: $color-white-text;
  stroke-width: 2;
  stroke-linejoin: miter;
  stroke-dasharray: 100;
  stroke-dashoffset: 100;
  fill-opacity: 0;
  opacity: 1;
  animation:
    arc-draw 620ms cubic-bezier(0.65, 0, 0.35, 1) both,
    arc-fill 420ms ease-out both;
  animation-delay: var(--arc-delay), calc(var(--arc-delay) + 480ms);
}

@keyframes arc-draw {
  from {
    stroke-dashoffset: 100;
  }
  to {
    stroke-dashoffset: 0;
  }
}

@keyframes arc-fill {
  from {
    fill-opacity: 0;
    stroke-width: 2;
    opacity: 1;
  }
  to {
    fill-opacity: 1;
    stroke-width: 0;
    opacity: var(--arc-opacity);
  }
}

@media (prefers-reduced-motion: reduce) {
  .is-animated .arc {
    animation: none;
    stroke: none;
    stroke-dashoffset: 0;
    fill-opacity: 1;
    opacity: var(--arc-opacity);
  }
}
</style>
